import { BottomActionBarV2, DialogV2, AritoIcon, AritoFormV2 } from '@/components/custom/erp';
import { ThongTinDoanhNghiep, ThongTinDoanhNghiepInput } from '@/types/schemas';
import { initialFormValues, type FormValues } from '../../schema';
import { useSearchFieldStates } from '../../hooks';
import { BasicInfoTab } from './BasicInfoTab';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: ThongTinDoanhNghiepInput) => void;
  formMode: 'add' | 'edit' | 'view';
  initialData?: ThongTinDoanhNghiep;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}: FormDialogProps) => {
  // Use the search field states hook to manage the state of the search fields
  const { taxAuthorityCuc, setTaxAuthorityCuc, taxAuthorityManagement, setTaxAuthorityManagement } =
    useSearchFieldStates(initialData);

  const handleSubmit = async (data: FormValues) => {
    try {
      const formattedData = {
        ...data,
        status: data.status || '1',
        // Add the tax authority IDs from the state
        ma_cqt0: taxAuthorityCuc?.uuid,
        ma_cqt: taxAuthorityManagement?.uuid
      } as unknown as ThongTinDoanhNghiepInput;

      onSubmit(formattedData);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title={`${formMode === 'add' ? 'Mới' : formMode === 'edit' ? 'Sửa' : 'Danh mục cơ quan thuế'}`}
      maxWidth='xl'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={281} />}
    >
      <AritoFormV2
        mode={formMode}
        hasAritoActionBar={false}
        // schema={FormSchema}
        onSubmit={handleSubmit}
        initialData={initialFormValues}
        className='w-[900px]'
        headerFields={
          <BasicInfoTab
            formMode={formMode}
            taxAuthorityCuc={taxAuthorityCuc}
            taxAuthorityManagement={taxAuthorityManagement}
            setTaxAuthorityCuc={setTaxAuthorityCuc}
            setTaxAuthorityManagement={setTaxAuthorityManagement}
          />
        }
        bottomBar={
          <BottomActionBarV2
            mode={formMode}
            onAdd={onAddButtonClick}
            onEdit={onEditButtonClick}
            onDelete={onDeleteButtonClick}
            onCopy={onCopyButtonClick}
            onSubmit={formMode !== 'view' ? () => {} : undefined}
            onClose={onClose}
          />
        }
      />
    </DialogV2>
  );
};

export default FormDialog;
